import type { AxiosError, AxiosInstance } from "axios";

export function createContentTypeV2Builder(apiClient: AxiosInstance) {
  return async function createContentTypeV2(data: {
    content: any;
  }): Promise<any> {
    try {
      const response = await apiClient.post("/v2/pages/", { ...data });
      return response.data;
    } catch (error: unknown) {
      if ((error as AxiosError).response?.status === 404) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
